// import React from "react";
// import './index.css'


// const Footer = () => {
//   return (
//     // <div className="footer" style={{background: "linear-gradient(135deg, #004d4d, #002626)",}}>
//     //   © {new Date().getFullYear()} UPL. All Rights Reserved.
//     // </div>

//   );
// };

// export default Footer;




import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Divider,
  Grid,
  Link,
  Stack,
} from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        // backgroundColor: '#ffffff',
        background:' linear-gradient(135deg,#f9f9f9,#e3e3e3)',
        py: { xs: 8, md: 10 },
      }}
    >
      <Container maxWidth="lg">
        {/* Top CTA Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            gap: 3,
            pb: 6,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '1.875rem', sm: '2.25rem' },
              fontWeight: 300,
              letterSpacing: '-0.02em',
              color: '#334155',
              flex: 1,
            }}
          >
            Ready to modernize your hiring workflow?
          </Typography>

          <Button
            href="#contact"
            variant="contained"
            sx={{
              backgroundColor: 'rgb(37, 99, 235)',
              color: 'white',
              textTransform: 'none',
              fontSize: '0.875rem',
              fontWeight: 500,
              borderRadius: '9999px',
              px: 3,
              py: 1.25,
              minWidth: '120px',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: '#334155',
                color:"white",
              },
              transition: 'background-color 0.3s',
            }}
          >
            Talk to Sales
          </Button>
        </Box>

        {/* Divider */}
        <Divider sx={{ my: 6, borderColor: 'rgba(0, 0, 0, 0.1)' }} />

        {/* Footer Grid */}
        <Grid container spacing={5} sx={{ mb: 6 }}>
          {/* Brand */}
          <Grid item xs={12} sm={6} lg={3}>
            <Typography
              variant="h6"
              sx={{
                fontSize: '1.125rem',
                fontWeight: 600,
                mb: 1.5,
                color: 'rgb(37, 99, 235)',
              }}
            >
              STRATEGIC HIRE.
            </Typography>
            <Typography
              sx={{
                fontSize: '0.875rem',
                color: 'rgba(0, 0, 0, 0.6)',
                lineHeight: 1.6,
              }}
            >
              Strategic Hire is an AI-powered hiring platform that helps enterprises
              streamline interviews, gain clarity, and make confident hiring decisions.
            </Typography>
          </Grid>

          {/* Product */}
          <Grid item xs={12} sm={6} lg={3}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                mb: 1.5,
                color: '#000000',
              }}
            >
              Product
            </Typography>
            <Stack spacing={1}>
              {['Overview', 'Interview Management', 'Analytics & Insights', 'Workflow Automation'].map(
                (item) => (
                  <Link
                    key={item}
                    href="#"
                    sx={{
                      fontSize: '0.875rem',
                      color: 'rgba(0, 0, 0, 0.6)',
                      textDecoration: 'none',
                      transition: 'color 0.3s',
                      '&:hover': {
                        color: '#000000',
                      },
                    }}
                  >
                    {item}
                  </Link>
                )
              )}
            </Stack>
          </Grid>

          {/* Resources */}
          <Grid item xs={12} sm={6} lg={3}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                mb: 1.5,
                color: '#000000',
              }}
            >
              Resources
            </Typography>
            <Stack spacing={1}>
              {['Documentation', 'Case Studies', 'Hiring Guides', 'Product Updates'].map(
                (item) => (
                  <Link
                    key={item}
                    href="#"
                    sx={{
                      fontSize: '0.875rem',
                      color: 'rgba(0, 0, 0, 0.6)',
                      textDecoration: 'none',
                      transition: 'color 0.3s',
                      '&:hover': {
                        color: '#000000',
                      },
                    }}
                  >
                    {item}
                  </Link>
                )
              )}
            </Stack>
          </Grid>

          {/* Company */}
          <Grid item xs={12} sm={6} lg={3}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                mb: 1.5,
                color: '#000000',
              }}
            >
              Company
            </Typography>
            <Stack spacing={1} sx={{ mb: 3 }}>
              {['About', 'Careers', 'Contact'].map((item) => (
                <Link
                  key={item}
                  href="#"
                  sx={{
                    fontSize: '0.875rem',
                    color: 'rgba(0, 0, 0, 0.6)',
                    textDecoration: 'none',
                    transition: 'color 0.3s',
                    '&:hover': {
                      color: '#000000',
                    },
                  }}
                >
                  {item}
                </Link>
              ))}
            </Stack>
            <Typography
              sx={{
                fontSize: '0.875rem',
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              hello@strategichire.ai
            </Typography>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            pt: 3,
            borderTop: '1px solid rgba(0, 0, 0, 0.1)',
            fontSize: '0.75rem',
            color: 'rgba(0, 0, 0, 0.6)',
          }}
        >
          <Typography sx={{ fontSize: '0.75rem', color: 'rgba(0, 0, 0, 0.6)' }}>
            © Strategic Hire. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={3}>
            <Link
              href="#"
              sx={{
                fontSize: '0.75rem',
                color: 'rgba(0, 0, 0, 0.6)',
                textDecoration: 'none',
                transition: 'color 0.3s',
                '&:hover': {
                  color: '#000000',
                },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="#"
              sx={{
                fontSize: '0.75rem',
                color: 'rgba(0, 0, 0, 0.6)',
                textDecoration: 'none',
                transition: 'color 0.3s',
                '&:hover': {
                  color: '#000000',
                },
              }}
            >
              Terms of Service
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
